<template>
  <div class="app-container circle-detail">
    <basic-container v-loading="detailLoading">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本资料" name="circleDetail">
          <div class="operation">
            <el-button v-show="isEdit" @click="cancelEdit">取消</el-button>
            <el-button type="primary" @click="switchMode">{{isEdit ? '保存' : '编辑'}}</el-button>
          </div>
          <el-row class="one-line one-line-flex">
            <el-col :span="2">封面图：</el-col>
            <el-col :span="16">
              <img class="cover-image" v-show="!isEdit" :src="coverImg | ossImageProcess" />
              <div>
                <div class="image">
                  <img class="cover-image" :src="coverImg | ossImageProcess" v-show="isEdit"/>
                </div>
                <div class="upload-btn" v-show="isEdit">
                  <el-button @click="handleImageChange" size="small" type="primary">重新上传</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="one-line one-line-flex">
            <el-col :span="2">名称：</el-col>
            <el-col :span="12" v-show="!isEdit">{{circleName}}</el-col>
            <el-col :span="16" v-show="isEdit">
              <el-input v-model.trim="circleName" :maxlength="10"></el-input>
            </el-col>
            <el-col v-show="isEdit" :span="2">
              <span class="limit">
                {{circleName ? circleName.length: 0}}/10
              </span>
            </el-col>
          </el-row>
          <el-row class="one-line one-line-flex">
            <el-col :span="2">描述：</el-col>
            <el-col :span="12" v-show="!isEdit">{{description}}</el-col>
            <el-col :span="12" v-show="isEdit">
              <el-input type="textarea" :rows="5" v-model.trim="description" :maxlength="50"></el-input>
            </el-col>
          </el-row>
          <el-row v-show="isEdit" class="one-line one-line-flex">
            <el-col :span="13"></el-col>
            <el-col :span="2">
              <span class="limit">
                {{description ? description.length: 0}}/50
              </span>
            </el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit">
            <el-col :span="2">帖子：</el-col>
            <el-col :span="12">{{postCount}}</el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit">
            <el-col :span="2">成员数：</el-col>
            <el-col :span="12">{{memberCount}}</el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit">
            <el-col :span="2">圈子类型：</el-col>
            <el-col :span="12">{{publicText}}</el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit && isPublic !== 'true'">
            <el-col :span="2"></el-col>
            <el-col :span="12">
              <div v-for="(permission, permissionIndex) in permissions" :key="permissionIndex" class="condition-group">
                <span>分组{{permissionIndex + 1}}：</span>
                <div class="condition-group-item">
                  <div v-for="(condition, conditionIndex) in permission.conditions" :key="conditionIndex" class="condition-display">
                    <span v-if="condition.tagType" class="condition-display-item">{{ tagTypes.find((v) => v.value === condition.tagType).label }}</span>
                    {{condition.filterTypeDesc}}
                    <span class="condition-display-item">{{condition.tagName}}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="one-line" v-show="isEdit">
            <el-col :span="2"> 圈子类型：</el-col>
            <el-col :span="12">
              <el-radio-group v-model="isPublic" @change="onChangePublic">
                <el-radio label="true">公有圈</el-radio>
                <el-radio label="false">私有圈</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="one-line" v-if="isEdit && isPublic !== 'true'">
            <el-col :span="2">
            </el-col>
            <el-col :span="5">
              <el-button size="small" type="primary" @click="onClickAddPermission">添加分组</el-button>
            </el-col>
          </el-row>
          <el-row v-if="isEdit && isPublic !== 'true'">
            <el-col :span="2"></el-col>
            <el-col :span="12">
              <div class="permission" v-for="(permission, permissionIndex) in permissions" :key="permissionIndex">
                <el-row>
                  <div class="condition" v-for="(condition, conditionIndex) in permission.conditions" :key="conditionIndex">
                    <el-col :span="6">
                      <el-select v-model="condition.tagType" placeholder="筛选类型">
                        <el-option
                          v-for="(item, index) in tagTypes"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2">
                      <i v-show="condition.tagType" class="icon el-icon-info" @click="getAllModalContent(condition.tagType)"></i>
                    </el-col>
                    <el-col :span="5">
                      <el-select v-model="condition.filterType" placeholder="筛选条件">
                        <el-option
                          v-for="(item, index) in filterTypes"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="5">
                      <el-input v-model="condition.tagName" placeholder="请输入筛选内容"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-col :span="3"></el-col>
                      <el-button size="medium"
                              type="text"
                              icon="icon-delete"
                              @click="onClickRemoveCondition(permissionIndex, conditionIndex)">
                      </el-button>
                    </el-col>
                    <el-col :span="2">
                      <el-col :span="3"></el-col>
                      <el-button v-show="condition.tagType && condition.filterType && condition.tagName"
                        class="filter-modal-btn"
                        size="small"
                        type="primary"
                        @click="getFilterModalContent(condition)">
                        查看所有符合条件的值
                      </el-button>
                    </el-col>
                  </div>
                </el-row>
                <el-row v-if="!!permissions[permissionIndex].conditions[0]">
                  <div class="condition">
                    <el-col :span="16"></el-col>
                    <el-col :span="2">
                      <el-button size="small" type="primary" @click="onClickRemovePermission(permissionIndex)">删除分组</el-button>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="2">
                      <el-button size="small" type="primary" @click="onClickAddCondition(permissionIndex)">添加条件</el-button>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit">
            <el-col :span="2">状态：</el-col>
            <el-col :span="16">{{activeText}}</el-col>
          </el-row>
          <el-row class="one-line" v-show="!isEdit">
            <el-col :span="2">创建时间：</el-col>
            <el-col :span="16">{{createdTime}}</el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="成员" name="circleMember">
          <div class="list-filter">
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input
                    clearable
                    class="list-filter-value"
                    @keyup.enter.native="searchChange"
                    v-model.trim="memberListQuery.nickname"
                    size="small"
                    placeholder="昵称"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input
                    clearable
                    class="list-filter-value"
                    @keyup.enter.native="searchChange"
                    v-model.trim="memberListQuery.unionId"
                    size="small"
                    placeholder="员工号"
                  ></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select class="list-filter-value" v-model="memberListQuery.isActive" clearable size="small" placeholder="状态">
                    <el-option
                      v-for="item in memberStatusTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-date-picker
                    class="list-filter-date"
                    v-model="memberListQuery.searchTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    size="small">
                  </el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button class="list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
                <el-button class="list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
              </el-col>
            </el-row>
          </div>
          <avue-crud
            ref="memberCrud"
            :page="memberPage"
            :data="memberTableData"
            :table-loading="memberTableLoading"
            :option="circleMemberOption"
            @current-change="memberCurrentChange"
            @refresh-change="getMemberList"
            @size-change="memberSizeChange"
          >
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <el-dialog
      :visible.sync="showNoticeContent"
      title="圈子公告"
      :close-on-click-modal="false"
      >
      <span>{{noticeContent}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeNoticeContent">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="600px"
      top="103px"
      :title="dialogTitle"
      :visible.sync="showDialog"
      :show-close="true"
      :close-on-click-modal="false"
      @closed="showDialog=false">
      <div v-if="!filterContent.length">暂无数据</div>
      <div class="dialog-content">
        <div class="dialog-item" v-for="(item, index) in filterContent" :key="index">{{item}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getObj,
  putObj,
  fetchMemberList,
  fetchNoticeList,
  switchNoticeStatus,
  getTagsByType,
} from '@/api/post/circle'
import {
  circleMemberOption,
  circleNoticeOption
} from '@/const/crud/post/circle'
import { getFileKeyAsync } from '@/util/util'
import { getOSSCircle } from '@/api/basic/aliyunoss'
import uploadService from '@/common/common-logic/upload-service'
import { filterTypesEnum, filterTypeMapping, tagTypesEnum, memberStatusTypesEnum, filterTypesValueEnum } from '@/const/circleFilterType';

const initDetail = vm => {
  getObj(vm.id).then(response => {
    formatDetail(vm, response.data.data)
  }).catch(error => {
    console.error(error)
    vm.$message({
      message: error,
      type: 'error'
    })
  })
  vm.getMemberList()
  vm.getNoticeList()
}

const formatDetail = (vm, data) => {
  vm.coverImg = data.coverImg
  vm.originCover = data.coverImg
  vm.circleName = formatEmptyData(data.circleName)
  vm.description = formatEmptyData(data.description)
  vm.location = formatEmptyData(data.location)
  vm.company = formatEmptyData(data.company)
  vm.isPublic = data.isPublic ? 'true' : 'false';
  vm.publicText = data.isPublic ? '公有' : '私有'
  vm.isActive = data.isActive
  vm.activeText = vm.isActive ? '已上架' : '已下架'
  vm.createdTime = data.insertedTime
  vm.permissions = formatPermissionData(data.permissions);
  if (data.postCount == null) vm.postCount = 0
  else vm.postCount = data.postCount
  if (data.memberCount == null) vm.memberCount = 0
  else vm.memberCount = data.memberCount
}

const formatFilterType = (data) => {
  return filterTypeMapping[data] || '';
};
const formatPermissionData = (data) => {
  let result = [];
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      const groupIndex = data[i].groupIndex;
      const item = {
        groupIndex,
        tagType: data[i].tagType,
        tagName: data[i].tagName,
        filterType: data[i].filterType,
        filterTypeDesc: formatFilterType(data[i].filterType)
      };
      if (result[groupIndex] && result[groupIndex].conditions) {
        result[groupIndex].conditions.push(item);
      } else {
        result.push({conditions: [item]})
      }
    }
  }
  return result;
}

const formatEmptyData = (data) => {
  if (data == null || data == '') return '--'
  else return data
}

const formatMemberData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(member => {
      return {
        id: member.id,
        name: member.name,
        phoneNumber: member.phoneNumber,
        location: member.location,
        company: member.company,
        industry: member.industry,
        isActive: member.isActive,
        activeText: member.isActive ? '正常' : '已退圈',
        joinedTime: member.joinedTime,
        unionId: member.unionId,
      }
    })
  } else {
    return []
  }
}

const formatNoticeData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(notice => {
      return {
        id: notice.id,
        content: notice.content,
        createdBy: notice.createdBy,
        createdName: notice.createdName,
        createdTime: notice.insertedTime,
        isActive: notice.isActive,
        activeText: notice.isActive ? '已上架' : '已下架'
      }
    })
  } else {
    return []
  }
}

export default {
  data() {
    return {
      activeName: 'circleDetail',
      isEdit: false,
      detailLoading: false,
      id: '',
      coverImg: '',
      originCover: '',
      showCover: true,
      circleName: '',
      description: '',
      industries: [],
      location: '',
      company: '',
      miniappCode: '',
      publicText: '',
      isActive: '',
      activeText: '',
      createdTime: '',
      postCount: '',
      memberCount: '',
      members: [],
      notices: [],
      memberTableData: [],
      memberPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      memberTableLoading: false,
      circleMemberOption: circleMemberOption,
      memberListQuery: {
        current: 1,
        size: 20,
        nickname: null,
        isActive: null,
        unionId: null,
      },
      noticeTableData: [],
      noticePage: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      noticeTableLoading: false,
      circleNoticeOption: circleNoticeOption,
      noticeListQuery: {
        current: 1,
        size: 20
      },
      showNoticeContent: false,
      noticeContent: '',
      circleTagOptions: [],
      memberOptions: [],
      isPublic: '',
      tagTypes: tagTypesEnum,
      filterTypesValue: filterTypesValueEnum,
      memberStatusTypes: memberStatusTypesEnum,
      tagType: '',
      filterTypes: filterTypesEnum,
      filterType: '',
      tagName:'',
      permissions: [{
        conditions: [{}],
      }],
      circlePermission: [],
      showDialog: false,
      filterContent: [],
      dialogTitle: '查看所有符合条件的值',
    }
  },
  computed: {
    startTime: function () {
      if (this.memberListQuery.searchTime && this.memberListQuery.searchTime.length > 0) {
        return this.memberListQuery.searchTime[0]
      } else {
        return null
      }
    },
    endTime: function () {
      if (this.memberListQuery.searchTime && this.memberListQuery.searchTime.length > 1) {
        return this.memberListQuery.searchTime[1]
      } else {
        return null
      }
    }
  },
  mounted() {
    this.isEdit = this.$route.path.includes('edit')
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    searchReset() {
      this.memberListQuery =  {
        nickname: null,
        isActive: null,
      };
      this.searchChange()
    },
    searchChange() {
      this.memberListQuery.currentPage = 1;
      this.memberListQuery.size = 20;
      this.getMemberList()
    },
    onChangePublic() {
      if (this.isPublic === 'true') {
        this.permissions = [{
          conditions: [{}],
        }];
      }
      this.publicText = this.isPublic === 'true' ? '公有' : '私有';
    },
    onClickRemoveCondition(permissionIndex, conditionIndex) {
      this.permissions[permissionIndex].conditions.splice(conditionIndex, 1);
    },
    onClickRemovePermission(permissionIndex) {
      this.permissions.splice(permissionIndex, 1);
    },
    onClickAddCondition(permissionIndex) {
      this.permissions[permissionIndex].conditions.push({});
    },
    onClickAddPermission() {
      this.permissions.push({
        conditions: [{}],
      });
    },
    getMemberList() {
      this.memberTableLoading = true
      fetchMemberList({...this.memberListQuery, startTime: this.startTime, endTime: this.endTime}, this.id).then(response => {
        this.memberTableData = formatMemberData(this, response.data.data.records)
        this.memberPage.total = response.data.data.total
        this.memberTableLoading = false
      }).catch(error => {
        console.error(error)
        this.memberTableLoading = false
        this.$message({
          message: '获取圈子成员失败',
          type: 'error'
        })
      })
    },
    memberCurrentChange(val) {
      this.memberPage.current = val
      this.memberListQuery.current = val
      this.getMemberList()
    },
    memberSizeChange(val) {
      this.memberPage.size = val
      this.memberListQuery.size = val
      this.getMemberList()
    },
    getNoticeList() {
      this.noticeTableLoading = true
      fetchNoticeList(this.noticeListQuery, this.id).then(response => {
        this.noticeTableData = formatNoticeData(this, response.data.data.records)
        this.noticePage.total = response.data.data.total
        this.noticeTableLoading = false
      }).catch(error => {
        console.error(error)
        this.noticeTableLoading = false
        this.$message({
          message: '获取圈子公告失败',
          type: 'error'
        })
      })
    },
    noticeCurrentChange(val) {
      this.noticePage.current = val
      this.noticeListQuery.current = val
      this.getNoticeList()
    },
    noticeSizeChagne(val) {
      this.noticePage.size = val
      this.noticeListQuery.size = val
      this.getNoticeList()
    },
    handleViewNotice(row, index) {
      this.noticeContent = row.content
      this.showNoticeContent = true
    },
    closeNoticeContent() {
      this.noticeContent = ''
      this.showNoticeContent = false
    },
    onClickSwitchNotice(row, index) {
      console.log(row)
      this.$confirm('是否确认' + (row.isActive ? '下架' : '上架') + 'ID为' + row.id + '的公告', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSwitchNotice(row)
      })
    },
    handleSwitchNotice(row) {
      switchNoticeStatus(this.id, row.id, row.isActive ? 0 : 1).then(response => {
        this.$message({
          message: row.isActive ? '下架成功' : '上架成功',
          type: 'success'
        })
        row.isActive = !row.isActive
        row.activeText = row.isActive ? '已上架' : '已下架'
      }).catch(error => {
        console.error(error)
      })
    },
    cancelEdit () {
      this.$refs.coverPicture.clearFiles();
      this.showCover = true;
      if (this.$route.path.includes('edit')) {
        this.$router.$avueRouter.closeTag()
        this.$router.go(-1)
      } else {
        this.isEdit = false
        initDetail(this)
      }
    },
    switchMode () {
      if (this.isEdit) {
        this.submit()
      } else {
        this.isEdit = true
      }
      this.$refs.coverPicture.clearFiles();
    },
    handleExceed () {
      this.$message({
        message: '只能选择一张图片',
        type: 'error'
      })
    },
    handleImageRemove () {
      this.coverImg = null
      if (this.originCover) {
        this.showCover = true
        this.$refs['originCover'].src = this.originCover
      }
    },
    async handleImageChange (file, fileList) {
       this.$openMaterialLib((list) => {
        if (!list || list.length === 0) {
          return;
        }
        this.coverImg = list[0].contentUrl
      }, 1);
    },
    validate () {
      if (!this.coverImg) {
        this.$message({
          message: '圈子封面不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.circleName) {
        this.$message({
          message: '圈子名称不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.description) {
        this.$message({
          message: '圈子描述不能为空',
          type: 'error'
        })
        return false
      }
      if (this.isPublic === 'false') {
        let isSuccess = this.circlePermission !== null && this.circlePermission.length > 0;
        if (isSuccess) {
          this.circlePermission.map(item => {
            if (! (item.groupIndex > -1 && !!item.tagName && !!item.filterType && !!item.tagType)) {
              isSuccess = false;
            }
          });
        }
        if (!isSuccess) {
            this.$message({
            message: '权限控制不能为空',
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    getParams () {
      const isPublic = this.isPublic === 'true';
      if (!isPublic) {
        this.circlePermission = this.formatPermissions(this.permissions)
      }
      return {
        id: this.id,
        circleName: this.circleName,
        circleType: 0,
        description: this.description,
        coverImg: this.coverImg,
        isPublic,
        permissions: this.circlePermission,
      }
    },
    formatPermissions(permissions) {
      let result = [];

      permissions.forEach((permission, groupIndex) => {
        permission.conditions.forEach(con => {
          result.push({...con, groupIndex});
        });
      });

      return result;
    },
    submit () {
      const params = this.getParams();
      if (!this.validate()) {
        return false
      }
      this.detailLoading = true
      putObj(params).then(response => {
        if (response.data.code === 0) {
          this.detailLoading = false
          if (this.$route.path.includes('edit')) {
            this.$router.$avueRouter.closeTag()
            this.$router.push({
              path: `/post/circle/detail/${this.id}`,
            })
          } else {
            this.originCover = this.coverImg
            this.isEdit = false
            initDetail(this);
          }
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.showCover = true;
        } else {
          this.$message({
            message: response.data.msg,
            type: 'error'
          })
          this.detailLoading = false
        }
      })
    },
    async getAllModalContent(type) {
      this.dialogTitle = '查看所有值';
      if (type) {
        const response = await getTagsByType(type);
        this.filterContent = response.data.data;
      }
      this.showDialog = true;
    },
    async getFilterModalContent(condition) {
      this.dialogTitle = '查看所有符合条件的值';
      let allContent;
      if (condition.tagType) {
        const response = await getTagsByType(condition.tagType);
        allContent = response.data.data;
      }
      if (!allContent.length) return;
      this.showDialog = true;
      const tagName = condition.tagName.trim().toLowerCase();
      switch(condition.filterType) {
        case this.filterTypesValue.EQUAL:
          this.filterContent = allContent.filter((v) => v.toLowerCase() === tagName);
          return;
        case this.filterTypesValue.NOT_EQUAL:
          this.filterContent = allContent.filter((v) => v.toLowerCase() !== tagName);
          return;
        case this.filterTypesValue.INCLUDE:
          this.filterContent = allContent.filter((v) => v.toLowerCase().indexOf(tagName) !== -1 );
          return;
        case this.filterTypesValue.NOT_INCLUDE:
          this.filterContent = allContent.filter((v) => v.toLowerCase().indexOf(tagName) === -1);
          return;
        default:
          return;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.circle-detail {
  .one-line {
    font-size: 14px;
    margin: 10px 0;
  }
  .one-line-flex {
    display: flex;
    align-items: center;
  }
  .limit {
    font-size: 14px;
    color: #AFAFAF;
    margin-left: 12px;
  }
  .cover-image {
    width: 148px;
    height: 148px;
    float: left;
    vertical-align: top;
    margin-right: 8px;
  }
  .upload-btn {
    display: flex;
    width: 148px;
    height: 148px;
    border: 3px #E4E7ED dashed;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .operation {
    text-align: right
  }
  .permission {
    display: flex;
    flex-direction: column;

    .condition {
      width: 800px;
      display: flex;
    }

    .add-btn {
      margin-left: 48px;
    }
  }

  .condition-group {
    display: flex;
    &-item {
      display: flex;
      flex-direction: column;
      .condition-display {
        margin-bottom: 10px;
        display: flex;
        &-item {
          background-color: #b4d7ff;
          padding: 3px 10px;
        }
      }
    }
  }
}

.list-filter {
  background-color: #fff;
  padding-top: 20px;
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }

  &-value {
    width: 96%!important;
  }

  &-date {
    width: 96%!important;
  }

  &-reset {
    float: right;
    margin-right: 8px;
  }

  &-search {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.icon {
  color: #66b1ff;
  margin: 5px 0 0 5px;
}
.filter-modal-btn {
  margin-top: -5px;
}
.dialog-content {
  max-height: 400px;
  overflow-y: auto;
}
.dialog-item {
  margin-bottom: 10px;
}
</style>

